export const videos = () => {

  const header = document.querySelector('.js-header');
  const main = document.querySelector('.js-main');

  function toggleSound(video){
    if( video.muted ) {
      video.muted = false;
    } else {
      video.muted = true;
    }
  }

  function togglePlayPause(video){
    if( video.paused ) {
      video.play();
    } else {
      video.pause();
    }
  }


  Array.from(document.getElementsByClassName("js-video")).forEach(function(item) {

    var buttonSound = item.querySelector('.js-toggle-sound');
    var buttonPlayPause = item.querySelector('.js-toggle-playpause');
    var video = item.querySelector('video');

    if( buttonSound && video ){

      buttonSound.addEventListener('click', function(e){
        e.preventDefault();
        toggleSound(video);
      });

    }

    if( buttonPlayPause && video ){

      buttonPlayPause.addEventListener('click', function(e){
        e.preventDefault();
        togglePlayPause(video);
      });

    }

  });


}
